export default "/96f0a6f8a70565a76f5a43000b8cfd7c.jpg";